import { createContext, useContext, useMemo, useState } from 'react';
import { toSearchText } from "utils/text";

const OrderEditContext = createContext(null);

const OrderEditProvider = ({ value, children }) => {
    const [openProductPicker, setOpenProductPicker] = useState(false);
    const [productFilter, setProductFilter] = useState({});
    const products = value?.products ?? [];

    const filterProducts = useMemo(() => {
        const info = productFilter?.info;
        if (info) {
            const search = toSearchText(info);
            return products.filter(x => x.product.search_text?.includes(search));
        }
        return [...products];
    }, [productFilter, products]);

    const setProductFilterValue = (name, value) => {
        const newFilter = { ...productFilter, [name]: value };
        setProductFilter(newFilter);
    };

    const providerValue = useMemo(() => {
        return {
            ...value,
            openProductPicker,
            setOpenProductPicker,
            filterProducts,
            setProductFilterValue,
        };
    }, [value, openProductPicker, filterProducts]);

    return (
        <OrderEditContext.Provider value={providerValue}>
            {children}
        </OrderEditContext.Provider>
    );
};

const useOrderEditContext = () => {
    return useContext(OrderEditContext);
};

export { OrderEditProvider, useOrderEditContext };
